<div class="payment-body" [ngClass]="isDesktop ? 'desktop': 'mobile'" fxLayoutAlign="start center" fxLayout="column">
    <div class="wrapper" fxLayoutAlign="space-between center" fxLayout="row" >
        <div *ngIf="isDesktop" class="payment-header">
            <div *ngIf="isDeposit" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="8">
                <div class="header-icon">
                  <img src="{{licenceService.getKey('icon-deposit')}}" alt="icon-deposit">
                </div>
                <div class="header-text" i18n>Deposit</div>
            </div>
            <div *ngIf="!isDeposit" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="8">
                <div class="header-icon">
                    <img src="{{licenceService.getKey('icon-withdrawal')}}" alt="icon-deposit">
                </div>
                <div class="header-text" i18n>Withdrawal</div>
            </div>
        </div>
        <nav mat-tab-nav-bar class="payment-nav-bar" color="accent">
            <a class="payment-tab-link" mat-tab-link [routerLink]="depositUrl" routerLinkActive="active" (click)="switchToDeposit()" >
                <div class="select-tab-container" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="8">
                    <div class="icon">
                        <img style="width: 32px;" src="{{licenceService.getKey('icon-deposit')}}" alt="icon-deposit">
                    </div>
                    <div class="text" i18n>Deposit</div>
                </div>
            </a>
            <a class="payment-tab-link" mat-tab-link [routerLink]="withdrawalUrl" routerLinkActive="active" (click)="switchToWithdrawal()">
                <div class="select-tab-container" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="8">
                    <div class="icon">
                        <img style="width: 32px;" src="assets/icons/icon-withdrawal.svg" alt="icon-deposit">
                    </div>
                    <div class="text" i18n>Withdrawal</div>
                </div>
            </a>
            <!-- <a *ngIf="isDesktop" class="payment-tab-link" mat-tab-link [routerLink]='["",editProfile]' routerLinkActive="active">
                <div class="select-tab-container" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="8">
                    <div class="icon">
                        <img src="assets/icons/icon-edit-profile.svg" alt="icon-deposit">
                    </div>
                    <div class="text" i18n>Edit profile</div>
                </div>
            </a> -->
        </nav>
    </div>
    <router-outlet></router-outlet>
</div>
